import { pushGaData } from '../common';
import { pathnameWithoutLang, toPath, toPathname } from '../utils';
export const LANGUAGES = ['et', 'ru', 'en'];
export const LOCALES = new Map([
    ['et', 'EST'],
    ['ru', 'RUS'],
    ['en', 'ENG'],
]);
const languageFilter = (option, showEnLang) => {
    return showEnLang || option !== 'en';
};
const isCurrentLanguage = (option, lang) => {
    return option === lang;
};
const getUrl = (pathname, lang, app, etLangPath, ruLangPath) => {
    if (app === 'online-help') {
        const path = toPath(pathname);
        path.splice(1, 0, lang);
        return toPathname(path) + window.location.search;
    }
    if (lang === 'ru' && ruLangPath) {
        return ruLangPath;
    }
    if (lang === 'et' && etLangPath) {
        return etLangPath;
    }
    const langPart = app !== 'itb' ? (lang === 'et' ? '' : `/${lang}`) : `/${lang}`;
    return `${langPart}${pathnameWithoutLang(pathname)}`;
};
const headerLanguages = (rootStore) => {
    const { app, lang, setLang } = rootStore.environmentStore;
    const { showEnLang, etLangPath, ruLangPath } = rootStore.propStateStore;
    const { translate, translations } = rootStore.translationsStore;
    const { currentPath } = rootStore.locationStore;
    if (translations) {
        return {
            items: LANGUAGES.filter((op) => languageFilter(op, showEnLang)).map((option) => {
                const label = translate(`header.lang.${option}`, 'global');
                return {
                    label,
                    current: isCurrentLanguage(option, lang),
                    url: getUrl(currentPath, option, app, etLangPath, ruLangPath),
                    onClick: (event) => {
                        event.preventDefault();
                        pushGaData({
                            eventAction: 'Change Language',
                            eventLabel: label,
                        });
                        return setLang(option);
                    },
                };
            }),
        };
    }
    return undefined;
};
export default headerLanguages;
//# sourceMappingURL=HeaderLanguages.js.map